export default "__VITE_PUBLIC_ASSET__ee438424__"